module.exports = __webpack_public_path__ + "static/machine-xs-c814986bcb44234011497d00d96ae13b.png";